export default "__VITE_ASSET__XIpQEwsW__"